import angular from 'angular';
import moment from 'moment';

angular
  .module('cxSettings')
  .controller('AddCompanyHolidayDialogCtrl', [
    '$element',
    '$http',
    '$scope',
    'authService',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    'companyId',
    addCompanyHolidayDialogCtrl,
  ]);

function addCompanyHolidayDialogCtrl(
  $element,
  $http,
  $scope,
  authService,
  appUrls,
  flySvc,
  close,
  dataCache,
  companyId,
) {
  var vm = this;
  vm.date = undefined;

  vm.save = function() {
    if (!vm.date) return;
    vm.saving = true;
    const formattedDate = moment.utc(vm.date).format('YYYY-MM-DD');

    var model = { companyId, date: formattedDate };

    $http({
      method: 'post',
      url: appUrls.api + '/api/companyholiday',
      data: model,
    })
      .then(function(response) {
        var result = response.data;
        $element.modal('hide');
        close(result, 500);
      })
      .catch(function(error) {
        flySvc.error(error);
      })
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
